function initAllSwipers() {
  const sw = window.innerWidth;
  const sh = window.innerHeight;
  
  if (typeof Swiper === "undefined") {
    console.warn("Swiper not loaded");
    return;
  }

  if (document.querySelector(".slider-left .swiper")) {
    new Swiper(".slider-left .swiper", {
      slidesPerView: "auto",
      allowTouchMove: false,
      loop: true,
      watchSlidesProgress: true,
      speed: 8000,
      spaceBetween: 100,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: { spaceBetween: 50 },
        576: { spaceBetween: 100 },
      },
    });
  }

  if (document.querySelector(".blogSlider .swiper")) {
    new Swiper(".blogSlider .swiper", {
      slidesPerView: "auto",
      loop: false,
      speed: 800,
      scrollbar: {
        el: ".blogSlider .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    });
  }

  if (document.querySelector(".testimonialSlider .swiper")) {
    new Swiper(".testimonialSlider .swiper", {
      slidesPerView: "auto",
      speed: 5000,
      loop: false,
      rewind: true,
      observeParents: true,
      observer: true,
      allowTouchMove: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }

  if (document.querySelector(".workCardsWrapper .swiper")) {
    if (sw < 1199 || (sw < 1400 && sw > 1300 && sh > 900)) {
      new Swiper(".workCardsWrapper .swiper", {
        slidesPerView: 1,
        loop: true,
        speed: 800,
        spaceBetween: 15,
      });
    }
  }

  const servicesSlider = document.querySelector(".serviceSlider__mob.swiper");
  if (servicesSlider) {
    if (sw < 1200 || (sw < 1400 && sw > 1300 && sh > 900)) {
      new Swiper(servicesSlider, {
        slidesPerView: 1,
        loop: true,
        speed: 800,
        spaceBetween: 15,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        breakpoints: {
          576: { slidesPerView: 2 },
          991: { slidesPerView: 3 },
        },
      });
    }
  }

  const serviceCardsSlider = document.querySelector(".serviceCards__slider");
  if (serviceCardsSlider) {
    const serviceCardsGrid = serviceCardsSlider.querySelector(".serviceCards__grid");
    const serviceCardsSlides = serviceCardsGrid?.querySelectorAll(".serviceCards__item");
    const cardsCarouselQuery = window.matchMedia("(max-width: 991.98px)");
    let serviceCardsSwiper;

    const updateServiceCardsSlider = () => {
      if (cardsCarouselQuery.matches && !serviceCardsSwiper && serviceCardsGrid && serviceCardsSlides) {
        serviceCardsSlider.classList.add("swiper");
        serviceCardsGrid.classList.add("swiper-wrapper");
        serviceCardsSlides.forEach((slide) => slide.classList.add("swiper-slide"));
        serviceCardsSwiper = new Swiper(serviceCardsSlider, {
          direction: "horizontal",
          slidesPerView: 1,
          loop: true,
          speed: 800,
          spaceBetween: 24,
          grabCursor: true,
          allowTouchMove: true,
          simulateTouch: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
        });
      } else if (!cardsCarouselQuery.matches && serviceCardsSwiper) {
        serviceCardsSwiper.destroy(true, true);
        serviceCardsSwiper = undefined;
        serviceCardsSlider.classList.remove("swiper");
        serviceCardsGrid.classList.remove("swiper-wrapper");
        serviceCardsSlides.forEach((slide) => slide.classList.remove("swiper-slide"));
      }
    };

    updateServiceCardsSlider();
    if (cardsCarouselQuery.addEventListener) {
      cardsCarouselQuery.addEventListener("change", updateServiceCardsSlider);
    } else {
      cardsCarouselQuery.addListener(updateServiceCardsSlider);
    }
  }

  if (document.querySelector(".technology-slider")) {
    const technologySlider = new Swiper(".technology-slider .swiper", {
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      speed: 1200,
      watchSlidesProgress: true,
      allowTouchMove: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });

    const technologytitleSlider = new Swiper(".title-slider .swiper", {
      slidesPerView: 1,
      loop: false, // ❌ no loop
      speed: 1200,
      effect: "fade",
      fadeEffect: { crossFade: true },
      allowTouchMove: false,
    });

    const technologytextSlider = new Swiper(".genericPanel.bottom .swiper", {
      slidesPerView: 1,
      loop: false, // ❌ no loop
      speed: 1200,
      effect: "fade",
      fadeEffect: { crossFade: true },
      allowTouchMove: false,
    });

    // 🔄 Sync using realIndex (IMPORTANT)
    technologySlider.on("slideChange", () => {
      const index = technologySlider.realIndex;

      technologytitleSlider.slideTo(index);
      technologytextSlider.slideTo(index);
    });
  }
}

export default initAllSwipers;
